import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // チケット購入履歴取得（企業単位）
  function getTicketData(){
    setErrorMessage("");
    axios.get(
      '/api/internal/usage_records/ticket_data', { params: { from_date: fromDate, to_date: toDate}}
    ).then(function (response) {
      let file_name = fromDate.replace(/-/g, '') + "-"+ toDate.replace(/-/g, '') + "_ticket_data"
      donwloadCsv(response.data.csv_data, file_name);
    }).catch(error => {
      setErrorMessage(error.response.data.message);
    }); 
  }

  // ビデオ通話回数取得（店舗単位）
  function getVideoCallCount(){
    setErrorMessage("");
    axios.get(
      '/api/internal/usage_records/videocall_count', { params: { from_date: fromDate, to_date: toDate}}
    ).then(function (response) {
      let file_name = fromDate.replace(/-/g, '') + "-"+ toDate.replace(/-/g, '') + "_videocall_count"
      donwloadCsv(response.data.csv_data, file_name);
    }).catch(error => {
      setErrorMessage(error.response.data.message);
    }); 
  }

  // ビデオ通話回数取得（店舗単位）
  function getMessageCount(){
    setErrorMessage("");
    axios.get(
      '/api/internal/usage_records/message_count', { params: { from_date: fromDate, to_date: toDate}}
    ).then(function (response) {
      let file_name = fromDate.replace(/-/g, '') + "-"+ toDate.replace(/-/g, '') + "_message_count"
      donwloadCsv(response.data.csv_data, file_name);
    }).catch(error => {
      setErrorMessage(error.response.data.message);
    }); 
  }

  // 先確認回数取得（店舗単位）
  function getInterviewCount(){
    setErrorMessage("");
    axios.get(
      '/api/internal/usage_records/interview_count', { params: { from_date: fromDate, to_date: toDate}}
    ).then(function (response) {
      let file_name = fromDate.replace(/-/g, '') + "-"+ toDate.replace(/-/g, '') + "_interview_count"
      donwloadCsv(response.data.csv_data, file_name);
    }).catch(error => {
      setErrorMessage(error.response.data.message);
    }); 
  }

  function donwloadCsv(csv_data, file_name){
    let data = csv_data.map((record)=>record.join(',')).join('\r\n');
    let bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
    let blob = new Blob([bom, data], {type: 'text/csv'});
    let url = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.download = file_name + ".csv"
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  return(
    <>
      { errorMessage && 
        <div className="alert alert-danger alert-dismissible" role="alert">
          <button type="button" className="close" data-dismiss="alert" aria-label="閉じる">
            <span aria-hidden="true">×</span>
          </button>
          { errorMessage }
        </div>
      }
      <div className="panel panel-success">
        <div className="panel-heading">利用実績出力</div>
        <div className="panel-body">
          <div className="row">
            <div className="form-group col-md-12">
              <div className="col-md-12">
              <label className="control-label">出力期間</label>
              </div>
              <div className="form-inline col-md-12">
                <div className="pos_relative pull-left">
                  <input type="date" className="form-control m5" placeholder="出力日時(from)" onChange={(e) => setFromDate(e.target.value)}/>
                </div>
                <div className="pos_relative pull-left m5">〜</div>
                <div className="pos_relative pull-left">
                  <input type="date" className="form-control m5" placeholder="出力日時(to)" onChange={(e) => setToDate(e.target.value)}/>
                </div>
              </div>
            </div>
          </div>
          {/* チケット購入数 */}
          <div className="row">
            <div className="form-group col-md-12">
              <div className="col-md-9">
                <label className="control-label">チケット購入数</label>
              </div>
              <div className="col-md-3">
                <a className="btn btn-primary col-md-6" onClick={() => getTicketData()}>CSV出力</a>
              </div>
            </div>
          </div>
          {/* ビデオ通話回数 */}
          <div className="row">
            <div className="form-group col-md-12">
              <div className="col-md-9">
                <label className="control-label">ビデオ通話回数</label>
              </div>
              <div className="col-md-3">
                <a className="btn btn-primary col-md-6" onClick={() => getVideoCallCount()}>CSV出力</a>
              </div>
            </div>
          </div>

          {/* 各種メッセージ回数 */}
          <div className="row">
            <div className="form-group col-md-12">
              <div className="col-md-9">
                <label className="control-label">メッセージ回数</label>
              </div>
              <div className="col-md-3">
                <a className="btn btn-primary col-md-6" onClick={() => getMessageCount()}>CSV出力</a>
              </div>
            </div>
          </div>

          {/* 先確認回数 */}
          <div className="row">
            <div className="form-group col-md-12">
              <div className="col-md-9">
                <label className="control-label">アンケート入力済み件数（GooCo連携済み）</label>
              </div>
              <div className="col-md-3">
                <a className="btn btn-primary col-md-6" onClick={() => getInterviewCount()}>CSV出力</a>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </>
  )
}
export default Index;